import { classifyVigrScore } from '../Meshes/Meshes';
import { useViewportInfoBox } from '../ViewportInfoBox/ViewportInfoBox';

const BUCKET_HEX = {
    low: '#ff261a',
    medium: '#ffa600',
    high: '#1ad933',
    none: '#808080',   // neutral gray, matches the no-data
};

export function useVigrSummary(containerRef, initialized, isVisible, meshes) {
    const score = meshes?.vigrStudyData?.score;
    const cutoffs = meshes?.vigrStudyData?.cutoffs;
    const row = { label: 'VIGR', value: 'No data', color: BUCKET_HEX.none };
    if (score != null) {
        row.value = `${score.toFixed(2)} ml/yr`;
        row.color = BUCKET_HEX[classifyVigrScore(score, cutoffs)];
    }
    useViewportInfoBox(containerRef, initialized, isVisible, { title: 'VIGR Summary', rows: [row] });
}
